<div class="card" style="border: 1px solid lightgray;">
  <div class="card-body">
    <div echarts [options]="strJson_Chart" class="demo-chart"></div>
  </div>
</div>